module.exports = __webpack_public_path__ + "static/media/Add_Button_Positive_Contribution_Fruit.2640aee2.svg";